angular.module("acl.common.globalNav", [
  "acl.angular.ui",
  "acl.common.filters",
  "acl.visualizer.archivePill",
  "acl.visualizer.model.metric",
  "acl.metrics.renameMetricPrompt",
]);
